import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchStudyHistory = async (
  authToken: string
): Promise<string[] | null> => {
  try {
    const { response, data } = await fetchFfdJson<{ body: string[]; text?: string }>(
      "/studies/history",
      authToken
    );
    if (response.ok) {
      return data.body ?? [];
    } else {
      if (data.text) alert(data.text);
      return null;
    }
  } catch (error) {
    alertAuthExpired();
    return null;
  }
};
